import { entryChannels } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function WhereToLookSection() {
  return (
    <section id="where" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="换网址了去哪里看"
          title="最新地址的六个查看渠道"
          desc="地址更换后，下面这些渠道都可能出现新入口。把它们组合起来使用，比只依赖单一渠道更不容易迷路。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {entryChannels.map((channel) => (
            <div
              key={channel.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/70 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${channel.icon} text-xl`}></i>
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] font-medium text-secondary-900">
                  {channel.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{channel.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{channel.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start gap-4 rounded-lg border border-primary-200 bg-primary-50 p-5 md:flex-row md:items-center md:justify-between md:p-6">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-information-line text-lg"></i>
            </span>
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">多渠道对照，别只信一个来源</p>
              <p className="mt-1 text-sm leading-relaxed text-foreground-700">
                当不同渠道给出的地址不一致时，以官方公告为准，并优先选择能稳定打开、页面完整的那一个。
              </p>
            </div>
          </div>
          <a
            href="#updates"
            className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回最新地址动态
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}